/**
 * @file
 * This file control the modal of accessing a different region link.
 */
(function ($, Drupal, drupalSettings) {

  var utils = Drupal.jnjethicon_product_localization_utils;

  var current_country = drupalSettings.current_location;

  // Get EPC cookie parse.
  var ethicon_epc_country = utils.parseCookie('ethicon_epc_country');

  if (ethicon_epc_country.length !== 0) {

    // Get current region from url.
    var pathname_region = utils.getRegionFromURL();

    // Cookie of HIDE modal.
    var ethicon_product_modal_hide = utils.getCookie('ethicon_epc_modal_hide');

    // When 'ethicon_product_modal_hide' is 1, do not show this modal.
    if ((ethicon_product_modal_hide != 1) && (pathname_region != ethicon_epc_country.region_code)) {
      $('#block-differentregionalertmodal').modal('show');
      var original_content = $('#block-differentregionalertmodal .field--name-field-block-body p strong').html();
      var replace = original_content.replace(original_content, current_country);
      var original_back_to = $('#block-differentregionalertmodal a.btn-dismiss').html();
      var replace_back_to = original_back_to.replace(/@country/g, ethicon_epc_country.country);
      $('#block-differentregionalertmodal .field--name-field-block-body p strong').html(replace);
      $('#block-differentregionalertmodal a.btn-dismiss').html(replace_back_to);
    }

    // Hide modal when click on 'YES'.
    $('#block-differentregionalertmodal a.btn-continue').on('click', function () {
      $('#block-differentregionalertmodal').modal('hide');
    });

    // When modal is closed by clicking on 'Yes' or outside it
    // set a cookie to do not show this modal again.
    $('#block-differentregionalertmodal').on('hide.bs.modal', function () {
      var $path = Drupal.behaviors.jnjethicon_common_utils.getPathName();
      utils.setCookie('ethicon_epc_modal_hide', 1, null, $path);
    });

    // When clicking on dismiss and 'Back to ...' redirects user to the home EPC
    // from previous configured cookie.
    $('#block-differentregionalertmodal a.btn-dismiss').on('click', function () {
      window.location.href = '/' + ethicon_epc_country.region_code + '/epc' + '?lang=' + ethicon_epc_country.redirect;
    });
  }

})(jQuery, Drupal, drupalSettings);

